import PopupFailedUploadedAgents from './PopupFailedUploadedAgents';

export default PopupFailedUploadedAgents;
